import React from 'react';
import { InputAdornment, Stack } from '@mui/material';
import { Modal, ModalProps } from 'components/Modal/Modal';
import { SecureTextField } from 'components/SecureTextField/SecureTextField';
import { TextField } from 'components/TextField/TextField';
import PasswordChecklist from 'components/SignUpForm/Steps/AccountCredentialsStep/PasswordChecklist';
import { useSignUpTestUser } from 'features/DeveloperTools/hooks/useSignUpTestUser';
import { Button } from 'components/Button/Button';

type SignUpTestUserProps = Omit<ModalProps, 'modalTitle' | 'modalTitleId'>;

export const SignUpTestUser = (props: SignUpTestUserProps) => {
  const {
    // Access Code
    accessCode,
    setAccessCode,
    accessCodeError,
    accessCodeHelperText,
    // Email
    email,
    setEmail,
    emailError,
    emailDomain,
    // Password
    password,
    setPassword,
    passwordValidationResults,
    // Form Validation
    isFormValid,
    handleSubmit,
    isRegisterUserLoading,
  } = useSignUpTestUser();

  return (
    <Modal
      {...props}
      showHeader
      modalTitle="Sign Up Test User"
      modalTitleId="sign-up-test-user-title"
    >
      <Stack direction="column" gap={2} padding={3}>
        <TextField
          id="test-user-access-code"
          label="Access Code"
          value={accessCode}
          onChange={(e) => setAccessCode(e.target.value)}
          error={accessCodeError}
          helperText={accessCodeHelperText}
        />
        <TextField
          id="test-user-email"
          label="Email Address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={emailError}
          helperText={emailError ? 'Invalid email address' : ''}
          slotProps={{
            input: {
              endAdornment: <InputAdornment position="end">{emailDomain}</InputAdornment>,
            },
          }}
        />
        <SecureTextField
          id="test-user-password"
          autoComplete="new-password"
          label="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <PasswordChecklist validationResults={passwordValidationResults} />
        <Button
          variant="primary"
          size="xlarge"
          disabled={!isFormValid}
          onClick={handleSubmit}
          isLoading={isRegisterUserLoading}
        >
          Create User
        </Button>
      </Stack>
    </Modal>
  );
};
